import { render, staticRenderFns } from "./TableChatList.vue?vue&type=template&id=1fd4352a&scoped=true"
import script from "./TableChatList.vue?vue&type=script&lang=ts"
export * from "./TableChatList.vue?vue&type=script&lang=ts"
import style0 from "./TableChatList.vue?vue&type=style&index=0&id=1fd4352a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4352a",
  null
  
)

export default component.exports